import { useAppSelector } from '../../hooks/redux'
import { Colors } from '../../constants/Colors'
import style from './Header.module.css'
import HeaderNav from './HeaderNav/HeaderNav'
import HeaderClick from './HeaderClick/HeaderClick'

interface Props {
    leftIcon: string | null,
    leftPath: string | null,
    leftClick: Function| null,
    title: string,
    rightIcon: string | null,
    rightPath: string | null,
    rightClick: Function | null
}

const Header = ({
    leftIcon,
    leftPath,
    leftClick,
    title,
    rightIcon,
    rightPath,
    rightClick}: Props
) => {
    
    const theme = useAppSelector<string>(state => state.theme.theme)

    return (
        <div
            className={style.container}
            style={{
                backgroundColor: Colors[theme].app
            }}
        >
            <div
                className={style.button}
            >
                {leftPath && leftIcon
                    ? <HeaderNav
                        icon={leftIcon}
                        path={leftPath}
                    />
                    : leftClick && leftIcon
                        ? <HeaderClick
                            icon={leftIcon}
                            onClick={leftClick}
                        />
                        : null
                }
            </div>

            <div
                className={style.titleContainer}
            >
                <h1
                    className={style.title}
                    style={{
                        color: Colors[theme ?? 'light'].activeTint
                    }}
                >
                    {title}
                </h1>
            </div>

            <div
                className={style.button}
            >
            {rightPath && rightIcon
                ? <HeaderNav
                    icon={rightIcon}
                    path={rightPath}
                />
                : rightClick && rightIcon
                    ? <HeaderClick
                        icon={rightIcon}
                        onClick={rightClick}
                    />
                    : null
            }
            </div>
        </div>
    )
}

export default Header
